//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return{
      nameList: [],
      vhostInfo:{}
    }
  },
  mounted(){
    this.finaceList()
    this.VhostConfig()
  },
  methods: {
    async VhostConfig() {
      let data = 'cmd=vhost_query&id='+this.$route.params.id;
      await this.$http.post('https://api.abeiyun.com/www/vhost.php', data).then(({data}) => {
        if(data.response == 200) {
          this.vhostInfo = data.msg
        }
      })
    },
    finaceList(){
      let data = 'cmd=domain_list&id='+this.$route.params.id;
      this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
        if(data){
          this.nameList = data
        }
      })
    },
    Add() {
      this.$router.push('/user/domainadd/'+ this.$route.params.id)
    },
    Delete(id) {
      let _this = this
      this.$vux.confirm.show({
        title: '确认',
        content: '您确定删除此绑定域名?',
        onConfirm () {
          let data = 'cmd=domain_bind'+
            '&cmd_type=del' +
            '&id=' + _this.$route.params.id +
            '&del_id=' + id
          _this.$http.post('https://api.abeiyun.com/www/vhost.php',data).then(({data})=>{
            if(data.response==200){
              _this.$vux.alert.show({
                title: '提示信息',
                content: data.msg,
                onHide () {
                  _this.finaceList()
                }
              })
            }
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/hostoperate/domainname.vue